import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Provider } from "react-redux";
import { Stack } from "@mantine/core";
import { store } from "./store.js";
import { StyleEditorProvider } from "./components/StyleEditorContext.js";
import { IntlProvider } from "./components/IntlProvider.js";
import { QueryProvider } from "./components/QueryProvider.js";
import { useChatSubscription } from "./hooks/useChatSubscription.js";
import { memo, useRef } from "react";
import { ChatInput } from "./views/Chat/ChatInput.js";
import { ChatSuggestions } from "./views/Chat/ChatSuggestions.js";
import { initStyle } from "./reducers/historyEnhancer.js";
import { useInitializeInStoreDuringRender } from "./hooks/redux.js";
export function StyleChatInputInner({ locale, style, accountName, captureEvent, onSendMessage, }) {
    const styleAndVersions = { ...style, versions: [style.version] };
    useInitializeInStoreDuringRender(initStyle, styleAndVersions);
    useChatSubscription(style.style.id);
    const inputRef = useRef(null);
    return (_jsx(IntlProvider, { locale: locale, children: _jsx(Provider, { store: store, children: _jsx(StyleEditorProvider, { mapkaAccountName: accountName, captureEvent: captureEvent, children: _jsxs(Stack, { gap: 24, children: [_jsx(ChatInput, { inputRef: inputRef, onSendMessage: onSendMessage }), _jsx(ChatSuggestions, { inputRef: inputRef })] }) }) }) }));
}
;
export const StyleChatInput = memo(props => (_jsx(QueryProvider, { children: _jsx(StyleChatInputInner, { ...props }) })));
